import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const AppropriatenessTestCategoryFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const appropriatenessTestCategories = useAppSelector(
    (state) => state.clients.appropriatenessTestCategories
  )
  const data = appropriatenessTestCategories.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 200 }}
    />
  )
}
